import { render, staticRenderFns } from "./form_list.vue?vue&type=template&id=45df4870"
import script from "./form_list.vue?vue&type=script&lang=js"
export * from "./form_list.vue?vue&type=script&lang=js"
import style0 from "./form_list.vue?vue&type=style&index=0&id=45df4870&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports